var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "viq-article-detail" },
    [
      _c("div", { staticClass: "viq-article-detail__meta" }, [
        _vm.article.source_type
          ? _c(
              "span",
              {
                staticClass: "viq-article-detail__badge",
                class: _vm.sourceTypeClass,
              },
              [_vm._v(_vm._s(_vm.formatSourceType(_vm.article.source_type)))]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.article.type
          ? _c(
              "span",
              {
                staticClass:
                  "viq-article-detail__badge viq-article-detail__badge--type",
              },
              [_vm._v("\n      " + _vm._s(_vm.article.type) + "\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.article.classification
          ? _c(
              "span",
              {
                staticClass: "viq-article-detail__badge",
                class: _vm.classificationClass,
              },
              [_vm._v(_vm._s(_vm.article.classification))]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("h2", { staticClass: "viq-article-detail__title" }, [
        _vm._v(_vm._s(_vm.article.title)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "viq-article-detail__info" }, [
        _vm.article.jurisdiction
          ? _c("div", { staticClass: "viq-article-detail__info-row" }, [
              _c("span", { staticClass: "viq-article-detail__info-label" }, [
                _vm._v("Jurisdiction"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "viq-article-detail__info-value" }, [
                _vm._v(_vm._s(_vm.article.jurisdiction)),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.article.vertical
          ? _c("div", { staticClass: "viq-article-detail__info-row" }, [
              _c("span", { staticClass: "viq-article-detail__info-label" }, [
                _vm._v("Vertical"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "viq-article-detail__info-value" }, [
                _vm._v(_vm._s(_vm.article.vertical)),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.article.published_date
          ? _c("div", { staticClass: "viq-article-detail__info-row" }, [
              _c("span", { staticClass: "viq-article-detail__info-label" }, [
                _vm._v("Published"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "viq-article-detail__info-value" }, [
                _vm._v(_vm._s(_vm.formatDate(_vm.article.published_date))),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.article.last_updated
          ? _c("div", { staticClass: "viq-article-detail__info-row" }, [
              _c("span", { staticClass: "viq-article-detail__info-label" }, [
                _vm._v("Updated"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "viq-article-detail__info-value" }, [
                _vm._v(_vm._s(_vm.formatDate(_vm.article.last_updated))),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.article.content
        ? _c("div", {
            staticClass: "viq-article-detail__content",
            domProps: { innerHTML: _vm._s(_vm.sanitizedContent) },
          })
        : _vm.displayExcerpts.length
        ? [
            _c(
              "div",
              { staticClass: "viq-article-detail__excerpt-section" },
              [
                _c(
                  "div",
                  { staticClass: "viq-article-detail__excerpt-label" },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 14 14",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M3 4h8M3 7h6M3 10h7",
                            stroke: "currentColor",
                            "stroke-width": "1.2",
                            "stroke-linecap": "round",
                          },
                        }),
                      ]
                    ),
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.displayExcerpts.length === 1
                            ? "Cited passage"
                            : "Cited passages"
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._l(_vm.displayExcerpts, function (exc, idx) {
                  return _c(
                    "blockquote",
                    { key: idx, staticClass: "viq-article-detail__excerpt" },
                    [_vm._v(_vm._s(exc))]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm.article.url
              ? _c(
                  "a",
                  {
                    staticClass: "viq-article-detail__load-full",
                    attrs: {
                      href: _vm.localUrl(_vm.article.url),
                      target: "_blank",
                      rel: "noopener noreferrer",
                    },
                  },
                  [
                    _vm._v("\n      View full article\n      "),
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "12",
                          height: "12",
                          viewBox: "0 0 12 12",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M5 1h6v6M11 1L5 7",
                            stroke: "currentColor",
                            "stroke-width": "1.2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.article.content && !_vm.article.excerpt
        ? _c("div", { staticClass: "viq-article-detail__empty" }, [
            _c("p", [
              _vm._v("No additional content available for this source."),
            ]),
            _vm._v(" "),
            _vm.article.url
              ? _c("p", { staticClass: "viq-article-detail__empty-hint" }, [
                  _vm._v(
                    '\n      Click "View on Platform" above to see the full source.\n    '
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.article.related && _vm.article.related.length > 0
        ? _c("ViqRelatedContent", { attrs: { items: _vm.article.related } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }